import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  colWidth?: string;
  move?:boolean;
  left?:string;
  margin?:string;
}

export const Root = styled.div`
  max-width: 1147px;
  width: auto;
  display:inline-block;
  border-radius: 5px;
  box-shadow: 0 4px 9px 0 rgba(0, 0, 0, 0.1);
  border: solid 1px rgba(130, 130, 130, 0.5);
  background-color: #ffffff;
  position:relative;
  margin-right:16px;
`;

export const MenuFilter = styled.div`
  width:530px;
  height: 408px;
  margin-top: 10px;
  display: none;
  position: absolute;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.1);
  background-color: #ffffff;
  z-index: 80;
  padding: 34px 0px;
  left: 0;
  right: 0;
  
  transition: margin-left 2s ease;
`
export const Container = styled.div`
  
`
export const List = styled.div`
  height: 408px;
  margin-right:5px;  
  overflow-x: hidden;
  overflow-y: auto;
  flex-direction: column;  
  position:relative;
  &:after{
      content: " ";
      position: absolute;
      border-left: 1px rgba(32, 64, 120, 0.2) solid;
      top: 0%;
      left: 0;
      height: 100%;
      margin-top: auto;
      margin-bottom: auto;
  }
`

export const Label = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: ${C.DARK_BLUE};
  padding: 0px 24px;
  margin-bottom:18px;
`

export const FilterContainer = styled.div`
  display:inline-block;
`;

export const ButtonFilter = styled.button`
  height: 35px;
  font-size: 16px;
  text-align: left;
  color: ${C.LIGHT_GRAY};
  padding: 0px 16px;
  border: unset;
  display:inline-block;
  background-color: #ffffff;
  cursor: pointer;
  margin: 0px 10px;
  &:hover, &:focus {
    color: ${C.DARK_GRAY};
    background-color: #f5f5f5;
    border-radius: 5px;
  }
  &:hover ~ ${MenuFilter} {
    display: block;
  }
  &:focus {
      outline: none;
  }
`